<template>
<Sidebar 
v-model:visible="$store.state.ui.show_ticket_modal" 
position="right"
class="p-sidebar-xl"
>

<div class="grid">
<div class="col-6 md:col-9"><h3 class="text-primary ">{{$store.state.languages.lang_phrases.destek_talepleri}}</h3></div>

<div class="col-6  md:col-3 flex justify-content-end align-items-center" v-if="display=='list'">
  <Button type="button"  icon="pi pi-times" :label="$store.state.languages.lang_phrases.iptal" class="p-button-danger p-button-outlined p-button-sm mr-2"  @click="close"/> 
 <Button type="button"  icon="pi pi-plus" :label="$store.state.languages.lang_phrases.yeni_ekle" class="p-button-primary p-button-outlined p-button-sm "  @click="addTicket"/> 
</div>
<div class="col-6  md:col-3 flex justify-content-end align-items-center" v-else>
 
 <Button type="button"  icon="pi pi-arrow-left" :label="$store.state.languages.lang_phrases.geri_don" class="p-button-primary p-button-outlined p-button-sm "  @click="backToList"/> 
</div>
</div>

<hr>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-else>

	<template v-if="display=='list'">
		<TicketsList :tickets="tickets" @displayTicket="displayTicket"></TicketsList>
	</template>
	<template v-if="display=='new'">
    <TicketAddNew :topics="topics" :brands="brands" @ticketAdded="backToList"></TicketAddNew>
  </template>
  <!-- show -->
  <template v-if="display=='show'">  

    <template v-if="loading_ticket">
      <FrameOverlay></FrameOverlay>
    </template>

    <template v-else>
      <TicketConversation :ticket="ticket"></TicketConversation>
    </template>  

  </template>
  <!-- show -->

	
</template>




</Sidebar>




</template>

<script>
import TicketsList from "./TicketsList"
import TicketAddNew from "./TicketAddNew"
export default {

  name: 'TicketModal',

  data () {
    return {
    	loading:false,
    	tickets:[],
    	display:"list",
    	newticket:{},
    	ticket:null,
      topics:[],
      brands:[],
      loading_ticket:false,
    }
  },
  components:{TicketsList,TicketAddNew},
  computed:{
  	show()
  	{
  		return this.$store.state.ui.show_ticket_modal
  	},
  },
  watch:{
  	show(newval)
  	{
  		if(newval)
  		{
  			this.getData()
  		}
  		else
  		{
  			this.display = "list"
  		}
  	}
  },
  methods:{
    async displayTicket(id)
    {      
      this.loading_ticket = await true
      this.display = await "show"
      this.ticket = await this.generalApiGet("tickets/show_supplier_user_ticket/"+id)             
      await this.$store.dispatch('tickets/setDisplayingTicket',this.ticket)  
      this.loading_ticket = await false
      this.$socket.emit('create_ticket_check_socket', { ticket_id: id })
      await setTimeout(()=>{
        var objDiv = document.getElementById("ticket_conversation");
        objDiv.scrollTop = objDiv.scrollHeight;
      },10)

    },
  	async getData()
  	{
  		this.loading = true
  		console.log("getdata")
  		let data = await this.generalApiGetWithoutLoader("tickets/supplier_user_tickets")
      this.tickets = await data.tickets
      this.brands = await data.brands
      if(this.brands.length>1)
      {
        this.topics = ["marka","proje","akis"]
      }
      else
      {
        this.topics = ["proje","akis"]
      }
  		await console.log(data)
  		this.loading = false
  	},
  	async addTicket()
  	{
  		this.display = "new"
  	},
    backToList()
    {
      this.display = "list"
      this.getData()
    },
    close()
    {
      this.$store.dispatch('ui/setShowTicketModal',false)
    }
  }
}
</script>

<style lang="css" scoped>
</style>